// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListMinimalCompaniesQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
  enabled: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  filterOnlyAccessible: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  hasEmployees?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type ListMinimalCompaniesQuery = { __typename?: 'Query' } & {
  listCompanies: { __typename?: 'ListCompanies' } & Pick<Types.ListCompanies, 'totalCount'> & {
      items: Array<
        { __typename?: 'Company' } & Pick<Types.Company, 'id' | 'name' | 'countryId' | 'enabled'> & {
            country: { __typename?: 'Country' } & Pick<Types.Country, 'name'>;
          }
      >;
    };
};

export const ListMinimalCompaniesDocument = /*#__PURE__*/ gql`
    query listMinimalCompanies($pageNumber: Int, $pageSize: Int, $keyword: String, $enabled: Boolean, $filterOnlyAccessible: Boolean, $hasEmployees: Boolean = false) {
  listCompanies(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, keyword: $keyword, enabled: $enabled, filterOnlyAccessible: $filterOnlyAccessible, hasEmployees: $hasEmployees}
  ) {
    items {
      id
      name
      countryId
      enabled
      country {
        name
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListMinimalCompaniesQuery__
 *
 * To run a query within a React component, call `useListMinimalCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMinimalCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMinimalCompaniesQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      keyword: // value for 'keyword'
 *      enabled: // value for 'enabled'
 *      filterOnlyAccessible: // value for 'filterOnlyAccessible'
 *      hasEmployees: // value for 'hasEmployees'
 *   },
 * });
 */
export function useListMinimalCompaniesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListMinimalCompaniesQuery, ListMinimalCompaniesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListMinimalCompaniesQuery, ListMinimalCompaniesQueryVariables>(
    ListMinimalCompaniesDocument,
    options,
  );
}
export function useListMinimalCompaniesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListMinimalCompaniesQuery, ListMinimalCompaniesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListMinimalCompaniesQuery, ListMinimalCompaniesQueryVariables>(
    ListMinimalCompaniesDocument,
    options,
  );
}
// @ts-expect-error
export function useListMinimalCompaniesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListMinimalCompaniesQuery, ListMinimalCompaniesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListMinimalCompaniesQuery, ListMinimalCompaniesQueryVariables>;
export function useListMinimalCompaniesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListMinimalCompaniesQuery, ListMinimalCompaniesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListMinimalCompaniesQuery | undefined, ListMinimalCompaniesQueryVariables>;
export function useListMinimalCompaniesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListMinimalCompaniesQuery, ListMinimalCompaniesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListMinimalCompaniesQuery, ListMinimalCompaniesQueryVariables>(
    ListMinimalCompaniesDocument,
    options,
  );
}
export type ListMinimalCompaniesQueryHookResult = ReturnType<typeof useListMinimalCompaniesQuery>;
export type ListMinimalCompaniesLazyQueryHookResult = ReturnType<typeof useListMinimalCompaniesLazyQuery>;
export type ListMinimalCompaniesSuspenseQueryHookResult = ReturnType<typeof useListMinimalCompaniesSuspenseQuery>;
